import i18n, { LanguageDetectorModule } from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationEN from '../locales/en/translation.json';
import translationZH_HK from '../locales/zh-HK/translation.json';
import translationZH_CN from '../locales/zh-CN/translation.json';

export const defaultNS = 'translation';

export const resources = {
  en: {
    translation: translationEN,
  },
  'zh-HK': {
    translation: translationZH_HK,
  },
  'zh-TW': {
    translation: translationZH_HK,
  },
  'zh-CN': {
    translation: translationZH_CN,
  },
} as const;

const mapQueryStringToLanguage = (queryString: string | null) => {
  switch (queryString) {
    case 'sc':
      return 'zh-CN';
    case 'tc':
      return 'zh-HK';
    default:
      return 'en';
  }
};

const customLanguageDetector: LanguageDetectorModule = {
  type: 'languageDetector',
  init: () => {},
  detect: () => {
    const urlParams = new URLSearchParams(window.location.search);
    const lang = urlParams.get('lang'); // Assuming your query parameter is 'lang'
    return mapQueryStringToLanguage(lang);
  },
  cacheUserLanguage: () => {},
};

i18n
  .use(LanguageDetector)
  .use(customLanguageDetector)
  .use(initReactI18next)
  .init({
    defaultNS,
    ns: ['translation'],
    resources,
    supportedLngs: ['en', 'zh-HK', 'zh-TW', 'zh-CN'],
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['customLanguageDetector', 'querystring'],
      lookupQuerystring: 'lang',
      caches: [],
    },
  });

document.documentElement.lang = i18n.language;

export default i18n;
